
<app-sub-header-toolbar title="New User Registration"></app-sub-header-toolbar>

<ion-content class="signup-content">

  <!-- OTP Verification View -->
  @if (isOTPSendReg) {
  <div class="signup-page-wrap">
    <div class="signup-card otp-card">

      <button type="button" class="card-close-btn" (click)="closeModal()" aria-label="Close">
        <ion-icon name="close-outline"></ion-icon>
      </button>

      <div class="signup-brand">
        <div class="brand-icon-box">
          <ion-icon name="shield-checkmark-outline"></ion-icon>
        </div>
        <ion-text class="brand-kicker">Verification</ion-text>
        <h2 class="brand-title">Enter your OTP</h2>
        <ion-text class="brand-sub">A 4-digit code was sent to {{ registerForm?.value?.Mobile1 }}.</ion-text>
      </div>

      <mat-progress-bar mode="determinate" [value]="66" class="signup-progress"></mat-progress-bar>

      <div class="otp-input-wrap">
        <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
        @if (invalidOTP) {
        <div class="otp-error">
          <ion-icon name="alert-circle-outline"></ion-icon>
          Invalid OTP, please verify and try again.
        </div>
        }
      </div>

      <div class="otp-actions">
        <ion-button expand="block" (click)="submitOTPReg()" [disabled]="!isvalid" class="btn-primary-action">
          <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
          Verify &amp; Continue
        </ion-button>
        <ion-button expand="block" fill="outline" (click)="back()" class="btn-secondary-action">
          <ion-icon slot="start" name="arrow-back-outline"></ion-icon>
          Go Back
        </ion-button>
      </div>

      <div class="login-footer">
        <ion-text class="footer-text">Already have an account?</ion-text>
        <button type="button" class="footer-link" (click)="goToLogin()" mat-button>
          <ion-icon name="log-in-outline"></ion-icon>
          Sign In
        </button>
      </div>

    </div>
  </div>
  }

  <!-- Registration Form View -->
  @else {
  <div class="signup-page-wrap">
    <div class="signup-card">

      <button type="button" class="card-close-btn" (click)="closeModal()" aria-label="Close">
        <ion-icon name="close-outline"></ion-icon>
      </button>

      <div class="signup-brand">
        <div class="brand-icon-box">
          <ion-icon name="person-add-outline"></ion-icon>
        </div>
        <ion-text class="brand-kicker">Get Started</ion-text>
        <h2 class="brand-title">Create your account</h2>
        <ion-text class="brand-sub">Use your business details to create a secure agent account.</ion-text>
      </div>

      <mat-progress-bar mode="determinate" [value]="33" class="signup-progress"></mat-progress-bar>

      <div class="step-indicator">
        <div class="step-item active">
          <div class="step-dot">
            <ion-icon name="create-outline"></ion-icon>
          </div>
          <span class="step-label">Fill Details</span>
        </div>
        <div class="step-line"></div>
        <div class="step-item">
          <div class="step-dot">
            <ion-icon name="shield-checkmark-outline"></ion-icon>
          </div>
          <span class="step-label">Verify OTP</span>
        </div>
        <div class="step-line"></div>
        <div class="step-item">
          <div class="step-dot">
            <ion-icon name="checkmark-done-outline"></ion-icon>
          </div>
          <span class="step-label">Done</span>
        </div>
      </div>

      <form name="registerForm" [formGroup]="registerForm" class="signup-form" novalidate>
        <div class="field-group">
          <div class="field-label-row">
            <ion-icon name="person-outline" class="field-icon"></ion-icon>
            <span class="field-label">Full Name <span class="required-star">*</span></span>
          </div>
          <mat-form-field appearance="outline" class="field-control">
            <mat-icon matPrefix>badge</mat-icon>
            <input matInput formControlName="FName" placeholder="e.g. Rahul Verma" />
            @if (showFieldError('FName')) {
            <mat-error>Full name is required.</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field-group">
          <div class="field-label-row">
            <ion-icon name="business-outline" class="field-icon"></ion-icon>
            <span class="field-label">Company Name <span class="required-star">*</span></span>
          </div>
          <mat-form-field appearance="outline" class="field-control">
            <mat-icon matPrefix>domain</mat-icon>
            <input matInput formControlName="CompanyName"
              placeholder="e.g. CloRent Factory Pvt. Ltd." />
            @if (showFieldError('CompanyName')) {
            <mat-error>Company name is required.</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field-group">
          <div class="field-label-row">
            <ion-icon name="call-outline" class="field-icon"></ion-icon>
            <span class="field-label">Mobile Number <span class="required-star">*</span></span>
          </div>
          <mat-form-field appearance="outline" class="field-control">
            <mat-icon matPrefix>phone_iphone</mat-icon>
            <input matInput type="tel" inputmode="numeric" maxlength="10" formControlName="Mobile1"
              placeholder="Enter 10-digit mobile no." />
            @if (showFieldError('Mobile1')) {
            <mat-error>{{ getMobileErrorMessage() }}</mat-error>
            }
            <mat-hint>This number receives your verification OTP.</mat-hint>
          </mat-form-field>
        </div>

        <div class="field-group">
          <div class="field-label-row">
            <ion-icon name="mail-outline" class="field-icon"></ion-icon>
            <span class="field-label">Email ID <span class="required-star">*</span></span>
          </div>
          <mat-form-field appearance="outline" class="field-control">
            <mat-icon matPrefix>alternate_email</mat-icon>
            <input matInput formControlName="Email"
              placeholder="e.g. rahul@company.com" />
            @if (showFieldError('Email')) {
            <mat-error>{{ getEmailErrorMessage() }}</mat-error>
            }
          </mat-form-field>
        </div>

        <ion-item lines="none" class="info-note" color="secondary">
          <ion-icon name="information-circle-outline" slot="start"></ion-icon>
          <ion-label>
            We send a one-time password to verify your mobile before account creation.
          </ion-label>
        </ion-item>

        <ion-button expand="block" (click)="attemptRegister()" class="btn-primary-action"
          [disabled]="registerForm.invalid">
          <ion-icon slot="start" name="send-outline"></ion-icon>
          Send OTP
        </ion-button>

      </form>

      <div class="login-footer">
        <ion-text class="footer-text">Already have an account?</ion-text>
        <button type="button" class="footer-link" (click)="goToLogin()" mat-button>
          <ion-icon name="log-in-outline"></ion-icon>
          Sign In
        </button>
      </div>

    </div>
  </div>
  }

</ion-content>